import { FC, useState } from "react"
import { ChevronDown, User } from "lucide-react"
import { Integration } from "../../../../../types"
import { classNames } from "../../../../utils"
import SectionCard from "../../../section-card"
import { AdvanceOptions, IntegrationOwnerSelector } from "../../fields"

interface Props {
  integration?: Integration
}

const AccessAdvancedSection: FC<Props> = ({ integration }) => {
  const [showAdvanced, setShowAdvanced] = useState(false)

  return (
    <SectionCard
      icon={<User size={15} />}
      title="Access & Advanced"
      right={
        <button
          type="button"
          onClick={() => setShowAdvanced(v => !v)}
          className="flex items-center gap-1.5 text-[13px] text-neutral-400 hover:text-neutral-600 transition-colors select-none"
        >
          Advanced options
          <ChevronDown
            size={14}
            className={classNames(
              "transition-transform duration-200",
              showAdvanced && "rotate-180"
            )}
          />
        </button>
      }
    >
      <div className="max-w-sm">
        <IntegrationOwnerSelector integration={integration} />
      </div>
      <AdvanceOptions integration={integration} open={showAdvanced} />
    </SectionCard>
  )
}

export default AccessAdvancedSection
